import { useTranslation } from 'react-i18next';
import { useMe } from '../auth/useMe';
import { useReviewQueueQuery } from './review-queue-api';

/** The count is capped visually; the accessible text always names the real number. */
const BADGE_CAP = 99;

/**
 * The number of posts waiting for an approval after "Freigaben" in the sidebar
 * (style guide 2.9a, S170-1), for members who may approve. Same review-queue
 * read as the start page, so both share one request. A failing or empty queue
 * draws nothing (the queue page has the error state).
 */
export function ReviewNavBadge() {
  const { t } = useTranslation();
  const canApprove = useMe().data?.active_tenant?.permissions.includes('content:approve') ?? false;
  if (!canApprove) return null;
  return <ReviewCount label={(count) => t('nav.reviewCount', { count })} />;
}

function ReviewCount({ label }: { label: (count: number) => string }) {
  const queue = useReviewQueueQuery();
  const count = queue.data?.length ?? 0;
  if (count === 0) return null;
  return (
    <>
      <span className="ui-badge ui-badge--warn" aria-hidden="true">
        {count > BADGE_CAP ? `${BADGE_CAP}+` : count}
      </span>
      <span className="ui-visually-hidden">{label(count)}</span>
    </>
  );
}
